import { MessageDescriptor } from "react-intl";

import { validatePayload as validateBulkExportPayload } from "../../../bulkexport/providers/SubscriptionProvider";

import { SubscriptionItemDraft, SubscriptionItemType } from "../../types";
import { subscriptionItemToDraft } from "../../utils";

import messages from "./SubscriptionEditProvider.messages";
import { ISubscriptionEditProviderProps } from "./SubscriptionEditProvider.types";
import { InitialItemDraft } from "./SubscriptionEditProvider.constants";

const NAME_MAX_LENGTH = 64;

export function validateDraft(draft: SubscriptionItemDraft) {
  const nameRegex = /^[a-zA-Z0-9\s\.\,\;\:\!\#\$\%\&\+\-\u2013\=\^\_\{\}\~\(\)]*$/g;
  const errors: Partial<Record<keyof SubscriptionItemDraft, MessageDescriptor>> = {};
  if (!draft.name) {
    errors.name = messages.nameRequired;
  } else {
    if (draft.name.length > NAME_MAX_LENGTH) {
      errors.name = messages.nameMaxLength;
    }
    if (!nameRegex.test(draft.name)) {
      errors.name = messages.nameCharacters;
    }
  }

  if (draft.type === SubscriptionItemType.BulkExport || draft.type === SubscriptionItemType.SavedBulkExport) {
    const payloadErrors = validateBulkExportPayload(draft.payload);

    if (payloadErrors) {
      errors.payload = Object.values(payloadErrors)[0];
    }
  }

  return Object.keys(errors).length === 0 ? null : errors;
}

export function getInitialDraftState(props: ISubscriptionEditProviderProps): SubscriptionItemDraft {
  if ("type" in props) {
    if (props.type === SubscriptionItemType.Slide) {
      return {
        ...InitialItemDraft,
        name: props.payload.title.substring(0, NAME_MAX_LENGTH),
        type: props.type,
        payload: props.payload,
      };
    }
    if (props.type === SubscriptionItemType.BulkExport) {
      return {
        ...InitialItemDraft,
        name: props?.payload?.title?.substring(0, NAME_MAX_LENGTH) || "",
        type: props.type,
        payload: props.payload,
      };
    }
    if (props.type === SubscriptionItemType.SavedBulkExport) {
      return {
        ...InitialItemDraft,
        name: props?.payload?.title?.substring(0, NAME_MAX_LENGTH) || "",
        type: props.type,
        payload: props.payload,
      };
    }
  }

  return subscriptionItemToDraft(props.subscriptionItem);
}
